"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useKeyboardAction = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 *
 * Hook for binding a behavior to a key.
 *
 * Right now this only supports binding keydown actions,
 * but it would be reasonable to extend this hook to handle
 * any desired keyboard action
 *
 * @param isActive: because this is a hook, we can't conditionally
 * call this function. However, we can pass `isActive`, and the keybinding will
 * only run if `isActive` is true.
 */
const useKeyboardAction = _ref => {
  let {
    keyDownBindings,
    isActive = true
  } = _ref;
  React.useEffect(() => {
    if (!isActive) {
      return;
    }
    const keyDownHandler = _ref2 => {
      let {
        key
      } = _ref2;
      keyDownBindings.forEach(keyDownBinding => {
        if (key === keyDownBinding.keyName) {
          keyDownBinding.onKeyDown();
        }
      });
    };
    // Add escape key listener
    window.addEventListener("keydown", keyDownHandler);
    // removes listeners on cleanup
    return () => {
      window.removeEventListener("keydown", keyDownHandler);
    };
  }, [isActive, keyDownBindings]);
};
exports.useKeyboardAction = useKeyboardAction;
//# sourceMappingURL=useKeyboardAction.js.map